import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoChargingSessionListLocationNameCell } from './emsp-bo-charging-session-list-location-name.cell';
import { EmspBoChargingSessionListLocationNameHeader } from './emsp-bo-charging-session-list-location-name.header';

export const EmspBoChargingSessionListLocationNameColumn: IdentifiedColumnDef<
  GatewayChargingSessionModel,
  GatewayChargingSessionModel['locationName']
> = {
  enableSorting: true,
  header: EmspBoChargingSessionListLocationNameHeader,
  cell: EmspBoChargingSessionListLocationNameCell,
  meta: { maxWidth: '110px', width: '80px', minWidth: '60px' },
};
